import { useState, useEffect } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputBankAccount from "../../helpers/InputBankAccount";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputTime from "../../helpers/InputTime";
import { UNSAFE_DataRouterStateContext } from "react-router-dom";
import InputSearchEmp from "../../helpers/InputSearchEmp";

import edit from "../../edit.png";


function ZajeciaEdit(props)
{    


    const defRow = {
            id: props.row.id,
            nazwa: props.row.nazwa,  
            kwota: props.row.kwota,  
            typ_rozliczania: props.row.typ_rozliczania,
            naliczaj_podczas_nieobecnosci: props.row.naliczaj_podczas_nieobecnosci,
            z_gory: props.row.z_gory,
            kwota_dla_nauczyciela: props.row.kwota_dla_nauczyciela,
            dzienniczek_obecnosci: props.row.dzienniczek_obecnosci,
            prowadzacy_px_group_id:props.row.prowadzacy_px_group_id,   
            lista_obecnosci: props.row.lista_obecnosci,
            archiwalne: props.row.archiwalne,    
            okres_od: props.row.okres_od,
            okres_do: props.row.okres_do,
            terminy: props.row.terminy,
            kwota_dla_nauczyciela: 0.00,
    };


    const [view, setView] = useState('btn');    
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState(defRow);


    const [dzien, setDzien] = useState('_x_');
    const [godzina, setGodzina] = useState('12:00');


    const valChangeListener = (filedName, val, correct, msg) => {


        if(filedName == 'dzien')
        {
            setDzien(val);
            return;
        }

        if(filedName == 'godzina')
            {
                setGodzina(val);
                return;
            }

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const saveData = () => {


 
 


        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }


        
        if(row.nazwa.length < 2) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Podaj nazwe' ,  "ok"  ,null); 
                return; 
            }


        if(row.terminy.length < 1) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Podaj min. jeden termin zajęć' ,  "ok"  ,null); 
                return; 
            }
       
        
 
        props.mainView.setProgress(-2);

        var req =  row;


        fetch( Config.url + '/rest_v1_calc,zajecia_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Informacje zostały zapisane" , "ok" , null);    
                       if(props.onUpdated != undefined) props.onUpdated(res.result);
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }



    const addDay = () => {

        if(dzien == '_x_') return;
        if(godzina.length < 3) return;

        var st = JSON.stringify(row.terminy);
        var stN = JSON.parse(st);

        var nx = stN.length + 1;
        nx = nx+"_" + (new Date() / 1000);

        stN.push(
            {
                num: nx,
                dzien_tygodnia: dzien,
                godzina: godzina,
            }
        );

        setRow({...row, ["terminy"]: stN });
    }

    const removeDay = (e) => {

            var num = e.target.getAttribute('num');
            var id = e.target.getAttribute('id');
           
          

        if(num != null && num != undefined)
        {
            var stNew = new Array();

            for(var k=0; k< row.terminy.length; k++)
            {
                if (row.terminy[k].num == num) continue;

                stNew.push(row.terminy[k]);
            }

            setRow({...row, ["terminy"]: stNew });
        }

        if(id != null && id != undefined)
            {
                var stNew = new Array();
    
                for(var k=0; k< row.terminy.length; k++)
                {
                    if (row.terminy[k].id == id) continue;
    
                    stNew.push(row.terminy[k]);
                }
    
                setRow({...row, ["terminy"]: stNew });
            }



    }


    const changeView = () => {
        if(view == 'btn') {setView("dlg"); }  else setView('btn');

       
        setRow(defRow);
    }   

    const empSelected = (id) => {

        setRow({...row, ["prowadzacy_px_group_id"]:id });
    }



    var itemTakNie = [
        { v: '_x_', title: '- - -' },
        { v: '0', title: 'Nie' }, 
        { v: '1', title: 'Tak' }, 
    ];



    var itemSposobNaliczania = [
        { v: '_x_', title: '- - -' },     
        { v: '1', title: 'Kwota za lekcje' }, 
        { v: '2', title: 'Kwota za miesiąc' }, 
    ];


    var itemDni = [
        { v: '_x_', title: '- - -' },      
        { v: '1', title: 'Poniedziałek' }, 
        { v: '2', title: 'Wtorek' }, 
        { v: '3', title: 'Środa' }, 
        { v: '4', title: 'Czwartek' }, 
        { v: '5', title: 'Piątek' }, 
        { v: '6', title: 'Sobota' }, 
        { v: '0', title: 'Niedziela' }, 
    ];



    var dlg_view =  (

        <div className="dlg_window dlg_type_xx shadowx">

                <div className="dlg_title">
                     Definicja stawki
                </div>


                <div className="dlg_content_x">


                                <div className="form_tab">
                                

                                    <div className="form_control">
                                        <div className="fieldName">Prowadzone przez* </div>
                                        <InputSearchEmp  mainView={props.mainView}  userData={props.userData} value={props.row.imie_nazwisko}  empSelected={empSelected}   err={errTab}  goNext={goNextNew} name="prowadzacy_px_group_id" placeholder={""} className=' ' req='1'   />
                                    </div>

                                     
                                    <div className="form_control">
                                        <div className="fieldName">Zajęcia prowadzone OD* </div>
                                        <InputDate   userData={props.userData} value={row.okres_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="okres_od" placeholder={""} className=' ' req='1'   />
                                    </div>

                                    <div className="form_control">
                                        <div className="fieldName">DO dnia* </div>
                                        <InputDate   userData={props.userData} value={row.okres_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="okres_do" placeholder={""} className=' ' req='1'   />
                                    </div>


                                    <div className="form_split"></div>


                                      <div className="form_control">
                                            <div className="fieldName">Archiwalne</div>
                                            <InputCombo  items={itemTakNie} value={row.archiwalne} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="archiwalne" placeholder={""} className='  ' req='1'   />
                                      </div>


                      

                                  
                                   

                                    <div className="form_control">
                                        <div className="fieldName">Nazwa* </div>
                                        <InputText   userData={props.userData} value={row.nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: np. Zajęcia sportowe, angielski, ..."} className=' w200 ' req='1' firstUp="1" />
                                    </div>

                                    <div className="form_control">
                                            <div className="fieldName">Kwota*</div>
                                            <InputDecimal   userData={props.userData} value={row.kwota} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kwota" placeholder={"Nazwa: np. Czesne, Danie I, Godziny pobytu, ... "} className=' w100 ' req='1' firstUp="1" />
                                        </div>
  

                                    <div className="form_control">
                                                <div className="fieldName">Sposób naliczania</div>
                                                <InputCombo  items={itemSposobNaliczania} value={row.typ_rozliczania} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ_rozliczania" placeholder={""} className='  ' req='1'   />
                                    </div>
 

                                    <div className="form_split"></div>


                                    <div className="form_control">
                                                <div className="fieldName">Naliczaj podczas nieobecności</div>
                                                <InputCombo  items={itemTakNie} value={row.naliczaj_podczas_nieobecnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="naliczaj_podczas_nieobecnosci" placeholder={""} className='  ' req='1'   />
                                    </div>
                              
 
                                    <div className="form_control">
                                                <div className="fieldName">Płatne z góry?</div>
                                                <InputCombo  items={itemTakNie} value={row.z_gory} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="z_gory" placeholder={""} className='  ' req='1'   />
                                    </div>


                                                                                             
                                    </div>

                                    <div className="form_tab">

                                        <div className="form_tab_title">Terminy zajęć</div>

                                            <div className="form_control">
                                                    <div className="fieldName">Dzień tygodnia</div>
                                                    <InputCombo  items={itemDni} value={dzien} err={errTab}  valChange={valChangeListener}  name="dzien"    />
                                            </div>

                                            <div className="form_control">
                                                    <div className="fieldName">Godzina</div>
                                                    <InputTime   value={godzina} err={errTab}  valChange={valChangeListener}  name="godzina"    />                                                    
                                            </div>

                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={addDay}>dodaj termin</div>

                                            <div className="form_split"></div>

                                            <div>
                                            {
                                                row.terminy.map( (tx, ix) => {

                                                    var strD = '';
                                                    if(tx.dzien_tygodnia == 0) strD = 'niedziela';
                                                    if(tx.dzien_tygodnia == 1) strD = 'poniedziałek';
                                                    if(tx.dzien_tygodnia == 2) strD = 'wtorek';
                                                    if(tx.dzien_tygodnia == 3) strD = 'środa';
                                                    if(tx.dzien_tygodnia == 4) strD = 'czwartek';
                                                    if(tx.dzien_tygodnia == 5) strD = 'piątek';
                                                    if(tx.dzien_tygodnia == 6) strD = 'sobota';



                                                    return <span onClick={removeDay} num={tx.num} id={tx.id}>
                                                        {strD} ({tx.godzina})  <sup className="link_color"  num={tx.num} id={tx.id} >usuń</sup>,  &nbsp;
                                                    </span>
                                                } )
                                            }
                                            &nbsp;
                                            </div>

                                    </div>

                                    <br/>


                                    <div className="form_control">                                            
                                        <div className="btn" onClick={saveData}>zapisz zmiany</div>
                                        &nbsp; &nbsp;
                                        <div className="btn" onClick={changeView}>anuluj</div>
                                    </div>

                </div>

            
        </div>
);

if(view == 'btn') dlg_view = null;


return  <div>              
            <img  onClick={changeView}  className="ibtn" src={edit} title="Zmień dane"    />  
            {dlg_view} 
       </div>


}


export default ZajeciaEdit;